import React from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

export const AddMedicine = () => {
  const navigate = useNavigate();
  return (
    <div className="addAdmin-container">
      <div className="addAdmin-subcontainer">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/manage-wholesaler-edit")}
        />
        <div className="add-title">Add Medicine</div>
      </div>
      <div className="addAdmin-content">
        <div className="addAdmin-contentLeft">
          <div className="addAdmin-field">
            <label>
              <span className="text-danger">*</span>Medicine Name
            </label>
            <div>
              {" "}
              <input type="text" placeholder="Enter Medicine Name" />
            </div>
          </div>

          <div className="addAdmin-field">
            <label><span className="text-danger">*</span>Stock Status</label>
            <div>
              <select className="admin-type">
                <option>Select stock status</option>
                <option>--</option>
                <option>--</option>
              </select>
            </div>
          </div>
        </div>
        <div className="addAdmin-contentRight">
          <div className="addAdmin-field">
            <label><span className="text-danger">*</span>Medicine Type</label>
            <div>
              <select className="admin-type">
                <option>Select medicine type</option>
                <option>--</option>
                <option>--</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      {/* bulk upload  */}
      <div className="addAdmin-subcontainer">
        <div className="add-title">Bulk Uplaod</div>
      </div>
      <div className="addAdmin-content">
        <div className="addAdmin-contentLeft">
          <div className="addAdmin-field">
            <label>
              <span className="text-danger">*</span>Bulk Upload
            </label>
            <div>
              {" "}
              <input type="file" />
            </div>
          </div>
        </div>
      </div>
      <div className="addbtnContainer">
        <div>
          <button className="admin-btnCancel">Cancel</button>
        </div>
        <div>
          <button className="add-btnSave">Save</button>
        </div>
      </div>
    </div>
  );
};
